module.exports = __webpack_public_path__ + "img/Assistance 2.97ae4222.svg";